import { useState } from "react";
import { useHistory } from "react-router-dom";
import { CloseButton } from "../../Components/CloseButton";
import Footer from "../../Components/Footer";
import ModalElement from "../../Components/Modal";
import { UserForm } from "../../Components/UserForm";
import { useUser } from "../../Providers/User";
import { Container, ContainerMenu, LoadingGif } from "./styles";
import { ServicesIcon } from "../../Components/MenuIcons/ServicesIcon";
import { HotelIcon } from "../../Components/MenuIcons/HotelIcon";
import { GuestIcon } from "../../Components/MenuIcons/GuestIcon";
import { ColabIcon } from "../../Components/MenuIcons/ColabIcon";
import { EditUserIcon } from "../../Components/MenuIcons/EditUserIcon";
import loading from "../../Assets/loading.svg";

const Dashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const { currentUser, isLoading, setIsLoading } = useUser();

  const history = useHistory();
  console.log(currentUser)

  if (currentUser && !isLoading) {
    return (
      <Container>
        <ContainerMenu>
          <ServicesIcon onClick={() => history.push("/products_services")} />
          <HotelIcon onClick={() => history.push("/unitHabits")} />
          <GuestIcon onClick={() => history.push("/products_services")} />
          <ColabIcon onClick={() => history.push("/colaborators")} />
          <EditUserIcon onClick={() => setShowModal(true)} />
          <CloseButton logoutButton />
        </ContainerMenu>

        <ModalElement closeModal={() => setShowModal(false)} isOpen={showModal}>
          <UserForm user={currentUser} />
        </ModalElement>
        <Footer />
      </Container>
    );
  } else if (!currentUser && !isLoading) {
    return (
      <Container>
        Seu token expirou
        <CloseButton logoutButton />
        <Footer />
      </Container>
    );
  } else {
    return (
      <Container>
        <LoadingGif className="loading" src={loading} alt="loading svg" />
      </Container>
    );
  }
};

export default Dashboard;
